module.exports = __webpack_public_path__ + "static/media/gvNu.830659d2.png";